import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languagePreferenceManager from '../lib/languagePreference';

// Import translation files
import authEn from '../common/locales/en/auth.json';
import authFr from '../common/locales/fr/auth.json';
import miscEn from '../common/locales/en/miscellaneous.json';
import miscFr from '../common/locales/fr/miscellaneous.json';
import errorsEn from '../common/locales/en/errors.json';
import errorsFr from '../common/locales/fr/errors.json';

const resources = {
  en: {
    auth: authEn,
    miscellaneous: miscEn,
    errors: errorsEn,
  },
  fr: {
    auth: authFr,
    miscellaneous: miscFr,
    errors: errorsFr,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: languagePreferenceManager.getStoredLanguagePreference(), // Get language from localStorage/cookies to persist user preference across reloads
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development', // Disable debug in tests and production
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  });

// Listen for language changes and sync to cookie for server-side access
i18n.on('languageChanged', (language) => {
  // Use centralized language preference manager
  languagePreferenceManager.setLanguagePreference(language);
});

export default i18n;
